module.exports = __webpack_public_path__ + "static/media/7.5a09d8b0.jpg";